import {
  IMediaplanItem,
  IOptionsMimicry,
} from "src/modules/mediaplans/models/mediaplans";
import { IEmoji } from "src/modules/mediaplans/models/emoji";
export interface IMediaPlansStateInterface {
  mediaplans: IMediaplanItem[];
  optionsMimicry: IOptionsMimicry;
  emojis: IEmoji[];
}

function state(): IMediaPlansStateInterface {
  return {
    emojis: [],
    mediaplans: [],
    optionsMimicry: {
      mental_guid: [],
      nation_guid: [],
      humorism_guid: [],
      agression_guid: [],
      brevity_guid: [],
      ideology_guid: [],
    },
  };
}

export default state;
